/* eslint-disable @dealersocket/dealersocket/file-names */
import * as colors from './v1.colors';
/* eslint @dealersocket/dealersocket/file-names: 1 */

var palette = {
  dangerLight: {
    light: colors.red50,
    main: colors.red100,
    dark: colors.red200
  },
  danger: {
    light: colors.red300,
    main: colors.red500,
    dark: colors.red800
  },
  dangerDark: {
    light: colors.red400,
    main: colors.red600,
    dark: colors.red900
  },
  warningLight: {
    light: colors.yellow50,
    main: colors.yellow100,
    dark: colors.yellow200
  },
  warning: {
    light: colors.yellow300,
    main: colors.yellow500,
    dark: colors.yellow800
  },
  warningDark: {
    light: colors.yellow400,
    main: colors.yellow600,
    dark: colors.yellow900
  },
  successLight: {
    light: colors.green50,
    main: colors.green100,
    dark: colors.green200
  },
  success: {
    light: colors.green300,
    main: colors.green500,
    dark: colors.green800
  },
  successDark: {
    light: colors.green400,
    main: colors.green600,
    dark: colors.green900
  },
  neutralLight: {
    light: colors.grey50,
    main: colors.grey100,
    dark: colors.grey200
  },
  neutral: {
    light: colors.grey300,
    main: colors.grey500,
    dark: colors.grey800
  },
  neutralDark: {
    light: colors.grey400,
    main: colors.grey600,
    dark: colors.grey900
  },
  highlight: {
    light: colors.blue50,
    main: colors.blue100,
    dark: colors.blue200
  },
  hover: {
    light: colors.themeA100,
    main: colors.themeA500,
    dark: colors.themeA900
  }
};
var unit = 8;
var spacing = {
  unit: unit,
  iconSize: 3 * unit,
  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopLeftNavMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 44,
  leftNavWidthFull: 230,
  leftNavSpacing: 12,
  iconButtonSize: 30,
  selectIconSize: 3.75 * unit,
  tableCellIconSize: 2.25 * unit,
  tableCellHorPadding: 1.875 * unit,
  tableCellVertPadding: 0.875 * unit,
  topNavHeight: 44
};
var sizes = {
  fieldWidth: 110,
  iconRippleSize: 4.5 * unit,
  rowFieldHeight: 44,
  wideFieldWidth: 110 * 2 + unit
};
export var dsv1 = {
  palette: palette,
  spacing: spacing,
  sizes: sizes
};